import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

// common variables
const mql = window.matchMedia('(min-width: 768px)');
const mqlLg = window.matchMedia('(min-width: 1024px)');

// reload on resize
mql.onchange = () => {
  location.reload();
};

mqlLg.onchange = () => {
  location.reload();
}

const details = document.querySelectorAll('.js-details');
const IS_OPENED_CLASS = 'is-opened';

const nav = document.getElementById('nav');
const navButton = document.getElementById('nav-button');

if (navButton && nav) {
  navButton.addEventListener('click', () => {
    navButton.classList.toggle('is-opened');
    nav.classList.toggle('is-opened');
  });
}

details.forEach((element) => {
  const summary = element.querySelector('.js-summary');
  const content = element.querySelector('.js-content');

  if (summary) {
    summary.addEventListener('click', (event) => {
      event.preventDefault();

      if (element.classList.contains(IS_OPENED_CLASS)) {
        element.classList.toggle(IS_OPENED_CLASS);

        closingAnim(content, element).restart();
      } else {
        element.classList.toggle(IS_OPENED_CLASS);

        element.setAttribute('open', 'true');

        openingAnim(content).restart();
      }
    });
  }
});

const closingAnim = (content: gsap.TweenTarget, element: Element) =>
  gsap.to(content, {
    height: 0,
    duration: 0.4,
    ease: 'power3.out',
    overwrite: true,
    onComplete: () => {
      element.removeAttribute('open');
    },
  });

const openingAnim = (content: gsap.TweenTarget) =>
  gsap.fromTo(
    content,
    {
      height: 0,
    },
    {
      height: 'auto',
      duration: 0.4,
      ease: 'power3.out',
      overwrite: true,
    }
  );

// side scroll
const sideScrollMounts: NodeListOf<Element> =
  document.querySelectorAll('.js-side-scroll');

if (mqlLg.matches && sideScrollMounts.length !== 0) {
  sideScrollMounts.forEach((mount: Element, index: number) => {
    const wrapper: Element = document.querySelectorAll(
      '.js-side-scroll-wrapper'
    )[index];
    const content = mount.querySelector('.js-side-scroll-content');

    if (content) {
      gsap.to(content, {
        x: () => -(content.clientWidth - wrapper.clientWidth),
        ease: 'none',
        scrollTrigger: {
          trigger: mount,
          start: 'top top',
          end: () => `+=${content.clientWidth - wrapper.clientWidth}`,
          scrub: true,
          pin: true,
          anticipatePin: 1,
          invalidateOnRefresh: true,
        },
        markers: true,
      });
    }
  });
}

// fixed viewport 320px
const viewport = document.querySelector('meta[name="viewport"]');
function switchViewport() {
  const value =
    window.outerWidth > 320
      ? 'width=device-width,initial-scale=1'
      : 'width=320';
  if (viewport && viewport.getAttribute('content') !== value) {
    viewport.setAttribute('content', value);
  }
}
addEventListener('resize', switchViewport, false);
switchViewport();
